import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import axios from "axios";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Delete, Edit } from "@mui/icons-material";
import { v4 as uuid } from "uuid";
import DatePicker from "react-datepicker";
import { getToken, base_url } from "../../config/config";

const AnrPlans = () => {
  const [apiData, setApiData] = useState([]);
  const [refreshId, setRefreshId] = useState(uuid());
  const [key, setKey] = useState(0);
  const [editData, setEditData] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const handleEditOpen = (rowData) => {
    setEditData(rowData);
    setIsEditOpen(true);
  };

  const handleEditClose = () => {
    setIsEditOpen(false);
  };

  const handleEditSave = async (editedData) => {
    try {
      const response = await axios.post(
        `${base_url}/v1/updateMiterbiterDate`,
        editedData,
      );
      const updatedProject = response.data;
      console.log("Updated project:", updatedProject);
      setApiData((prevData) =>
        prevData.map((project) =>
          project._id === updatedProject._id ? updatedProject : project,
        ),
      );
      setIsEditOpen(false);
    } catch (error) {
      console.error("Error updating project:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.post(`${base_url}/v1/deleteProject`, { id });
      const data = response.data;
      console.log(data);
      if (data.success) {
        setApiData((prevData) =>
          prevData.filter((project) => project._id !== id),
        );
        setKey((prevKey) => prevKey + 1);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    axios
      .get(`${base_url}/v1/getAllAnrCalendar`)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setApiData(response.data);
        } else {
          console.error("Error fetching API data:", response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching API data:", error);
      });
  }, [refreshId]);

  useEffect(() => {
    const tableContainer = document.getElementById("table-container");
    if (tableContainer) {
      const tableContentHeight = tableContainer.scrollHeight;
      tableContainer.style.height = `${tableContentHeight}px`;
    }
  }, [apiData]);

  const columns = useMemo(
    () => [
      {
        id: "project",
        header: "Project",
        columns: [
          {
            accessorKey: "number",
            header: "Number",
            size: 150,
          },
          {
            accessorKey: "date",
            header: "Date",
            size: 150,
          },
          {
            accessorKey: "process",
            header: "Process",
            size: 500,
            Cell: ({ row }) => (
              <ul>
                {row.original.process.map((proc) => (
                  <li key={proc._id}>
                    <strong>Title:</strong> {proc.title} <br />
                    <strong>Days:</strong> {proc.days} <br />
                    <strong>Mitarbeiter:</strong> {proc.miterbiter}
                  </li>
                ))}
              </ul>
            ),
          },
          {
            accessorKey: "actions",
            header: "Actions",
            Cell: ({ row }) => (
              <>
                <Button
                  variant='outlined'
                  onClick={() => handleDelete(row.original._id)}
                  startIcon={<Delete />}>
                  Delete
                </Button>
                <Button
                  variant='outlined'
                  onClick={() => handleEditOpen(row.original)}
                  startIcon={<Edit />}>
                  Edit
                </Button>
              </>
            ),
          },
        ],
      },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: apiData,
    initialState: { density: "compact" },
  });

  return (
    <div style={{ margin: "20px" }} key={key}>
      <div
        id='table-container'
        style={{ overflow: "hidden", marginBottom: "20px" }}>
        <MaterialReactTable table={table} />
      </div>
      <Button
        variant='contained'
        color='primary'
        onClick={() => window.print()}
        style={{ marginTop: "20px" }}>
        Print Table
      </Button>

      {/* Edit modal */}
      <Dialog open={isEditOpen} onClose={handleEditClose}>
        <DialogTitle>Edit Project</DialogTitle>
        <DialogContent>
          {editData && (
            <form>
              <TextField
                autoFocus
                margin='dense'
                label='Number'
                fullWidth
                value={editData.number}
                disabled
                onChange={(e) =>
                  setEditData({ ...editData, number: e.target.value })
                }
              />
              {/* <DatePicker
        selected={editData.date}
        onChange={(e) => setEditData({ ...editData, date: e.target.value })}
              
        dateFormat="dd/MM/yyyy"
      /> */}
              <TextField
                margin='dense'
                label='Date'
                fullWidth
                value={editData.date}
                onChange={(e) =>
                  setEditData({ ...editData, date: e.target.value })
                }
              />
              {/* {editData.process.map((proc, index) => (
                <div key={proc._id}>
                  <TextField
                    margin="dense"
                    label={`Title ${index + 1}`}
                    fullWidth
                    value={proc.title}
                    onChange={(e) => {
                      const updatedProcess = [...editData.process];
                      updatedProcess[index].title = e.target.value;
                      setEditData({ ...editData, process: updatedProcess });
                    }}
                  />
                  <TextField
                    margin="dense"
                    label={`Days ${index + 1}`}
                    fullWidth
                    value={proc.days}
                    onChange={(e) => {
                      const updatedProcess = [...editData.process];
                      updatedProcess[index].days = e.target.value;
                      setEditData({ ...editData, process: updatedProcess });
                    }}
                  />
                  <TextField
                    margin="dense"
                    label={`Mitarbeiter ${index + 1}`}
                    fullWidth
                    value={proc.miterbiter}
                    onChange={(e) => {
                      const updatedProcess = [...editData.process];
                      updatedProcess[index].miterbiter = e.target.value;
                      setEditData({ ...editData, process: updatedProcess });
                    }}
                  />
                </div>
              ))} */}
            </form>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClose} color='secondary'>
            Cancel
          </Button>
          <Button onClick={() => handleEditSave(editData)} color='primary'>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AnrPlans;
